import { Badge } from '@/client/components/ui/badge';
import { cn } from '@/client/lib/utils';

export type InvoiceStatus = 'DRAFT' | 'SENT' | 'PAID' | 'OVERDUE';

const STATUS_CONFIG: Record<InvoiceStatus, { label: string; dot: string; badge: string }> = {
  DRAFT: {
    label: 'Draft',
    dot: 'bg-muted-foreground',
    badge: 'border-border text-muted-foreground',
  },
  SENT: {
    label: 'Sent',
    dot: 'bg-blue-500',
    badge:
      'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-400',
  },
  PAID: {
    label: 'Paid',
    dot: 'bg-good',
    badge: 'border-good/30 bg-good-bg text-good',
  },
  OVERDUE: {
    label: 'Overdue',
    dot: 'bg-destructive',
    badge: 'border-destructive/30 bg-destructive/10 text-destructive',
  },
};

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  const cfg = STATUS_CONFIG[status];
  return (
    <Badge variant="outline" className={cn('gap-1.5 font-medium', cfg.badge)}>
      <span className={cn('h-1.5 w-1.5 rounded-full', cfg.dot)} />
      {cfg.label}
    </Badge>
  );
}
